export default __webpack_public_path__ + "static/media/virtualCardBackside.d5c6c71c.png";